<template>
  <div class="app-box">
    <div class="boelanb">
      <div class="header" v-if="ulFlex">
        免费全网影视VIP视频vip会员免广告看电影！
        若播放异常，刷新，更换接口尝试哦!
      </div>
      <div v-else class="meorasdd">
      <van-notice-bar
          left-icon="volume-o"
          background="#f0f9eb"
          color="#67c23a"
          text="免费全网影视VIP视频vip会员免广告看电影！
        若播放异常，刷新，更换接口尝试哦！"
        />
      </div>
      <iframe
        class="iframeBox"
        webkitallowfullscreen=""
        mozallowfullscreen=""
        allowfullscreen=""
        :src="videSrc"
        width="100%"
        height="300"
      >
        <p>你的浏览器不支持iframes。</p>
      </iframe>
      <div class="tabLet" v-if="ulFlex">
        <div class="li1">
          <el-select
            class="selWidth"
            v-model="selectedIndex"
            placeholder="请选择"
            @change="tabClick"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="index"
            >
            </el-option>
          </el-select>
        </div>
        <div class="li2">
          <el-input
            v-model="input"
            clearable
            placeholder="输入视频链接,点击解析播放,无法播放请切换接口"
          ></el-input>
        </div>
        <div class="li3">
          <el-button class="buttomCle" type="primary" @click="jeixiClick"
            >解析播放</el-button
          >
        </div>
      </div>
      <!-- end移动样式 -->
      <div v-else>
      <div class="maoepoor">
        <el-select
          class="selWidth"
          v-model="selectedIndex"
          placeholder="请选择"
          @change="tabClick"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="index"
          >
          </el-option>
        </el-select>
      </div>
      <div class="maoepoor">
        <el-input
          v-model="input"
          clearable
          placeholder="输入视频链接,点击解析播放,无法播放请切换接口"
        ></el-input>
      </div>
      <div class="maoepoor">
        <el-button  class="buttomCle" type="primary" @click="jeixiClick"
          >解析播放</el-button
        >
      </div>
      </div>
      <!-- end -->

      <div class="header font" v-if="ulFlex">
        免费全网影视VIP视频vip会员免广告看电影！
        若播放异常，刷新，更换接口尝试哦！
      </div>

      <div class="ulFlex" v-if="ulFlex">
        <div class="liFlex">
          <a target="_blank" href="https://v.qq.com/">
            <img src="../../src/assets/vqq.png" alt="" />
          </a>
        </div>
        <div class="liFlex">
          <a target="_blank" href="https://www.youku.com/">
            <img src="../../src/assets/youku.png" alt="" />
          </a>
        </div>
        <div class="liFlex">
          <a target="_blank" href="https://www.bilibili.com/">
            <img src="../../src/assets/bilibili.png" alt="" />
          </a>
        </div>
        <div class="liFlex">
          <a target="_blank" href="https://www.iqiyi.com/">
            <img src="../../src/assets/iqiyi.png" alt="" />
          </a>
        </div>
        <div class="liFlex">
          <a target="_blank" href="http://www.le.com/">
            <img src="../../src/assets/le.png" alt="" />
          </a>
        </div>
        <div class="liFlex">
          <a target="_blank" href="https://www.mgtv.com/">
            <img src="../../src/assets/mgtv.png" alt="" />
          </a>
        </div>
        <div class="liFlex">
          <a target="_blank" href="https://www.pptv.com/">
            <img src="../../src/assets/pptv.png" alt="" />
          </a>
        </div>
        <div class="liFlex">
          <a target="_blank" href="https://tv.sohu.com/">
            <img src="../../src/assets/sohu.png" alt="" />
          </a>
        </div>
      </div>
      <p class="text1">
        <a
          href="http://wpa.qq.com/msgrd?v=3&amp;uin=964502906&amp;site=qq&amp;menu=yes"
          target="_blank"
          class="iconfont textP icon---"
          title="点我"
        >
          无法播放，我要反馈，侵权我要反馈点我
        </a>
      </p>
      <!-- end 瀑布流 -->
      <div class="Waterfall" v-if="!ulFlex">
        <div class="watLi">
          <a target="_blank" href="https://v.qq.com/">
             <img src="../../src/assets/vqq.png" alt="">
          </a>
        </div>
         <div class="watLi">
          <a target="_blank" href="https://www.youku.com/">
             <img src="../../src/assets/youku.png" alt="">
          </a>
        </div>
         <div class="watLi">
          <a target="_blank" href="https://www.bilibili.com/">
             <img src="../../src/assets/bilibili.png" alt="">
          </a>
        </div>
         <div class="watLi">
          <a target="_blank" href="https://www.iqiyi.com/">
             <img src="../../src/assets/iqiyi.png" alt="">
          </a>
        </div>
         <div class="watLi">
          <a target="_blank" href="http://www.le.com/">
             <img src="../../src/assets/le.png" alt="">
          </a>
        </div>
         <div class="watLi">
          <a target="_blank" href="https://www.mgtv.com/">
             <img src="../../src/assets/mgtv.png" alt="">
          </a>
        </div>
         <div class="watLi">
          <a target="_blank" href="https://www.pptv.com/">
             <img src="../../src/assets/pptv.png" alt="">
          </a>
        </div>
         <div class="watLi">
          <a target="_blank" href="https://tv.sohu.com/">
             <img src="../../src/assets/sohu.png" alt="">
          </a>
        </div>
        
      </div>
      <p class="text1">
        本站不提供、不存储、不传播任何视频资源，一切资源来源于互联网开源接口，仅供测试和学习交流，如有违规请联系我们QQ964502906
      </p>
      <p class="text1">
        本站由<a target="_blank" href="https://menghn.com/">menghn.com</a>提供技术支持
      </p>
      <p class="text2 textret">
        © CopyRight 2018-{{time|formatDate('yyyy')}} 三七VIP全网视频解析, Rights Reserved. 版权所有.
      </p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);

const PARSE_OPTIONS = [
        {
          url: "https://player.uono.uno/line.php?n=9&url=",
          label: "小魏列表解析",
        },
        {
          url: "https://jx.xmflv.com/?url=",
          label: "小魏解析",
        },
        {
          url: "https://jx.xmflv.cc/?url=",
          label: "小魏解析1",
        },
        {
          url: "https://www.8090.la/8090/?url=",
          label: "小魏解析2",
        },
        {
          url: "http://api.apii.top/?v=",
          label: "小魏解析3",
        },
        {
          url: "https://player.uono.uno/line.php?n=5&url=",
          label: "小魏解析4",
        },
        {
          url: "https://jx.aidouer.net/?url=",
          label: "Bilibili解析",
        },
        {
          url: "https://jx.xmflv.com/?url=",
          label: "优酷腾讯通道",
        },
        {
          url: "https://qsy.ctrlqq.com/?if",
          label: "短视频去水印",
        }

];

export default {
  data() {
    return {
      videSrc: window.location.href + "About",
      selectedIndex: 0,
      options: PARSE_OPTIONS,
      input: "",
      morHttp: "",
      ulFlex: "",
      time:new Date()
    };
  },
  filters:{
        formatDate: function(value,args) {
            var dt = new Date(value);
            if(args == 'yyyy-M-d') {// yyyy-M-d
            let year = dt.getFullYear();
            let month = dt.getMonth() + 1;
            let date = dt.getDate();
            return `${year}-${month}-${date}`;
        } else if(args == 'yyyy'){// yyyy-M-d H:m:s
            let year = dt.getFullYear();
            let month = dt.getMonth() + 1;
            let date = dt.getDate();
            let hour = dt.getHours();
            let minute = dt.getMinutes();
            let second = dt.getSeconds();
            return `${year}`;
        } else if(args == 'yyyy-MM-dd') {// yyyy-MM-dd
            let year = dt.getFullYear();
            let month = (dt.getMonth() + 1).toString().padStart(2,'0');
            let date = dt.getDate().toString().padStart(2,'0');
            return `${year}-${month}-${date}`;
        } else {// yyyy-MM-dd HH:mm:ss
            let year = dt.getFullYear();
            let month = (dt.getMonth() + 1).toString().padStart(2,'0');
            let date = dt.getDate().toString().padStart(2,'0');
            let hour = dt.getHours().toString().padStart(2,'0');
            let minute = dt.getMinutes().toString().padStart(2,'0');
            let second = dt.getSeconds().toString().padStart(2,'0');
            return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
        }
        }
    },
  created() {
    this.morHttp = this.options[this.selectedIndex].url;
  },

  mounted() {
    if (this._isMobile()) {
      this.ulFlex = false;
    } else {
      this.ulFlex = true;
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    jeixiClick() {
      const raw = (this.input || "").trim();
      if (!raw) {
        Toast("请输入视频链接");
        return;
      }
      Toast("正在解析请稍等,如解析失败请自行更换接口");
      this.videSrc = this.morHttp + raw;
    },
    tabClick(index) {
      this.morHttp = this.options[index].url;
    },
  },
};
</script>

<style scoped>
.header {
  width: 100%;
  height: 40px;
  line-height: 40px;
  color: #67c23a;
  background-color: #f0f9eb;
  font-size: 18px;
  border-radius: 4px;
  margin: 10px auto;
}
.app-box {
  margin-bottom: 25px;
}
.boelanb {
  width: 80%;
  margin: auto;
}
.tabLet {
  display: flex;
}
.tabLet .li1 {
  flex: 1;
  text-align: left;
}
.tabLet .li2 {
  flex: 4;
  margin: 0 10px;
}
.tabLet .li3 {
  flex: 1;
  text-align: right;
}
.tabLet .li3 .buttomCle {
  width: 100%;
}
.selWidth {
  width: 100%;
}
.iframeBox {
  margin-bottom: 10px;
  border: none;
  height: 500px;
}
.font {
  background-color: #fdf6ec;
  color: #e6a23c;
}
.text1 {
  font-size: 15px;
  color: #606266;
  margin-bottom: 40px;
  text-align: center;
}
.text2 {
  color: #000;
}
.header {
  text-align: center;
}
.textret {
  text-align: center;
}
.ulFlex {
  display: flex;
}
.liFlex {
  flex: 1;
}
.liFlex img {
  width: 128px;
  margin: 8px;
}
.app-box::before {
  background: #000
    linear-gradient(
      to left,
      #4cd964,
      #5ac8fa,
      #007aff,
      #34aadc,
      #5856d6,
      #ff2d55
    );
  content: "";
  height: 5px;
  position: absolute;
  top: 0;
  width: 100%;
}
.postab {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 15px;
}
.postab1 {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 15px;
  color: #000;
}
.postab2 {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 15px;
  color: #000;
}
.postab21 {
  position: absolute;
  bottom: 70px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 15px;
  color: #000;
}
.maoepoor{
  margin-bottom: 10px;
}
.maoepoor .buttomCle{
  width: 100%;
}
.Waterfall{
  width: 100%;
  column-count: 2;
	column-gap: 0;
}
.Waterfall .watLi{
  margin-bottom: 10px;
}
.meorasdd{
  margin: 15px 0 15px 0;
}
</style>